import { TokenService } from './../../shared/services/token.service';
import { RecoverPasswordService } from './../services/recover-password.service';
import { Component, OnInit, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';

import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { LoginService } from '../services/login.service';
import { LoginValidationService } from './../services/login-validation.service';
// Servicio de alertas
import { SwalService } from '../../shared/services/swal.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
})
export class LoginPageComponent implements OnInit {
  loginForm: FormGroup;
  tipos_usuario: any;

  _loading: boolean;

  public cliente: boolean;
  public proveedor: boolean;
  public empleado_compra: boolean;
  public bodega: boolean;

  showLoading: boolean;

  /**
   * Intentos
   */
  loginTries = 0;

  constructor(
    private formBuilder: FormBuilder,
    public location: Location,
    public router: Router,
    public _login: LoginService,
    private _token: TokenService,
    private _loginValidation: LoginValidationService,
    private _recoverPass: RecoverPasswordService,
    private _swal: SwalService
  ) {}

  ngOnInit() {
    this.showLoading = true;

    this.tipos_usuario = [];
    this._loading = true;

    this.loginForm = this.formBuilder.group({
      username: new FormControl(null, [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(190),
      ]),
      password: new FormControl(null, [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(50),
      ]),
      tipo_usuario: new FormControl(null, [Validators.required]),
    });

    if (localStorage.getItem('uni_perms')) {
      this.ifUserLogged();
    } else {
      this.userTypesList();
      this.showLoading = false;
    }
  }
  /**
   * Chequeo de si el usuario está loggeado por medio del token en localstorage
   */
  ifUserLogged() {
    if (localStorage.getItem('token')) {
      const userType = parseInt(this._loginValidation.getUserRoles(), 10);
      this._loginValidation.getTipoUsuario(userType);
    }
  }
  /**
   * Trae el array tipos de usuarios para la lista de tipos de usuarios en el login
   */
  userTypesList() {
    this._login.tipoUsuario().subscribe((data) => {
      this.tipos_usuario = data['tipo_usuario'];
      console.log(this.tipos_usuario);
      this._loading = false;
    });
  }
  /**
   * Getter del formulario para mejor manejo
   */
  get f() {
    return this.loginForm.controls;
  }
  /**
   * Envio de datos para loggearse
   */
  onLogin() {
    console.log(this.loginForm.value);
    // Si el usuario falla 3 veces, se le desactiva el formulario por un tiempo
    if (this.loginTries === 3) {
      this.loginForm.disable();

      this._swal.showWarningModal(
        'Excediste los intentos',
        'Debes esperar 15 minutos para intentar loggearte nuevamente.'
      );

      setTimeout(() => {
        this.loginTries = 0;
        this.loginForm.enable();
      }, 900000);
    } else {
      this.showLoading = true;

      if (this.loginForm.valid) {
        this.loginTries++;
        /**
         * Se guarda el tipo de usuario seleccionado en el localStorage
         * para después chequear por medio de los Guards de Cliente y Proveedor
         */
        const arrUserType = [];
        arrUserType.push(this.f.tipo_usuario.value);
        this._loginValidation.setTipoUsuario(arrUserType);

        this._login
          .loginUsuario(this.loginForm.value)
          .toPromise()
          .then((data) => {
            console.log(data);

            const token = data['access_token'];
            // Se setea el token
            this._token.setToken(token);
            this._swal.showSuccessNotification('Iniciaste sesión exitosamente');
            this._loginValidation.getTipoUsuario(this.f.tipo_usuario.value);
          })
          .catch((error) => {
            console.log(error);

            localStorage.clear();
            this.showLoading = false;

            if (error.error['message'] === 'Usuario no encontrado') {
              this._swal.showErrorModal(
                'Oops...',
                'Usuario no encontrado, por favor, verifica los datos ingresados.'
              );
            } else {
              this._swal.showErrorModal(
                'Oops',
                `${JSON.stringify(error.error['message'])}`
              );
            }
          });
      } else {
        console.log(this.loginForm.value);

        this._swal.showErrorModal(
          'Faltan datos en el formulario',
          'Selecciona tu tipo de usuario, coloca tu NIT o email y contraseña'
        );

        this.showLoading = false;
      }
    }
  }

  /**
   * Abrir modal de recuperación de contraseña
   */
  openRecoverPassword() {
    this._recoverPass.openRecoverPasswordModal();
  }
}
